/** @type {readonly string[]} */
export const BUILDING_TYPES_EN = [
  "Office",
  "Warehouse",
  "Production / Manufacturing",
  "Retail",
  "Laboratory",
  "Data centre",
  "Other",
];

const pad = (n) => String(n).padStart(2, "0");
const fmt = (d) =>
  `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${String(d.getFullYear()).slice(-2)}`;

export const DEFAULT_ACCOUNTING_PERIODS = (() => {
  const startMonths = [1, 4, 7, 10];
  const out = [];
  for (let y = 2022; y <= 2026; y++) {
    for (const m of startMonths) {
      const start = new Date(y, m - 1, 1);
      const end = new Date(y + 1, m - 1, 0);
      out.push(`${fmt(start)} - ${fmt(end)} (${end.getFullYear()})`);
    }
  }
  return out;
})();

export const OWNERSHIP_OPTIONS_EN = [
  "Wholly owned asset",
  "Leased",
  "Partially owned",
  "Franchise",
];

/** EU member-state codes → Danish country names (Lovable NewFacility). */
export const EU_COUNTRIES = [
  { code: "SE", name: "Sverige" },
  { code: "DE", name: "Tyskland" },
  { code: "NL", name: "Holland" },
  { code: "FR", name: "Frankrig" },
  { code: "PL", name: "Polen" },
  { code: "NO", name: "Norge" },
  { code: "FI", name: "Finland" },
  { code: "AT", name: "Østrig" },
  { code: "BE", name: "Belgien" },
  { code: "ES", name: "Spanien" },
  { code: "IT", name: "Italien" },
  { code: "PT", name: "Portugal" },
  { code: "IE", name: "Irland" },
  { code: "CZ", name: "Tjekkiet" },
  { code: "HU", name: "Ungarn" },
  { code: "GR", name: "Grækenland" },
  { code: "RO", name: "Rumænien" },
  { code: "BG", name: "Bulgarien" },
  { code: "HR", name: "Kroatien" },
  { code: "SI", name: "Slovenien" },
  { code: "SK", name: "Slovakiet" },
  { code: "LT", name: "Litauen" },
  { code: "LV", name: "Letland" },
  { code: "EE", name: "Estland" },
  { code: "LU", name: "Luxembourg" },
  { code: "CY", name: "Cypern" },
  { code: "MT", name: "Malta" },
];

/** Full list for dropdowns (Danish names, Lovable). */
export const ALL_COUNTRIES = [
  "Afghanistan",
  "Albanien",
  "Algeriet",
  "Andorra",
  "Angola",
  "Argentina",
  "Armenien",
  "Aserbajdsjan",
  "Australien",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belgien",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnien-Hercegovina",
  "Botswana",
  "Brasilien",
  "Brunei",
  "Bulgarien",
  "Burkina Faso",
  "Burundi",
  "Cambodja",
  "Cameroun",
  "Canada",
  "Centralafrikanske Republik",
  "Chile",
  "Colombia",
  "Comorerne",
  "Congo",
  "Costa Rica",
  "Cuba",
  "Cypern",
  "Danmark",
  "Djibouti",
  "Dominica",
  "Dominikanske Republik",
  "Ecuador",
  "Egypten",
  "El Salvador",
  "Elfenbenskysten",
  "Eritrea",
  "Estland",
  "Eswatini",
  "Etiopien",
  "Fiji",
  "Filippinerne",
  "Finland",
  "Forenede Arabiske Emirater",
  "Frankrig",
  "Gabon",
  "Gambia",
  "Georgien",
  "Ghana",
  "Grenada",
  "Grækenland",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Holland",
  "Honduras",
  "Hviderusland",
  "Indien",
  "Indonesien",
  "Irak",
  "Iran",
  "Irland",
  "Island",
  "Israel",
  "Italien",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kasakhstan",
  "Kenya",
  "Kina",
  "Kirgisistan",
  "Kiribati",
  "Kosovo",
  "Kroatien",
  "Kuwait",
  "Laos",
  "Lesotho",
  "Letland",
  "Libanon",
  "Liberia",
  "Libyen",
  "Liechtenstein",
  "Litauen",
  "Luxembourg",
  "Madagaskar",
  "Malawi",
  "Malaysia",
  "Maldiverne",
  "Mali",
  "Malta",
  "Marokko",
  "Marshalløerne",
  "Mauretanien",
  "Mauritius",
  "Mexico",
  "Mikronesien",
  "Moldova",
  "Monaco",
  "Mongoliet",
  "Montenegro",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Nordkorea",
  "Nordmakedonien",
  "Norge",
  "Oman",
  "Pakistan",
  "Palau",
  "Panama",
  "Papua Ny Guinea",
  "Paraguay",
  "Peru",
  "Polen",
  "Portugal",
  "Qatar",
  "Rumænien",
  "Rusland",
  "Rwanda",
  "Saint Kitts og Nevis",
  "Saint Lucia",
  "Saint Vincent og Grenadinerne",
  "Salomonøerne",
  "Samoa",
  "San Marino",
  "São Tomé og Príncipe",
  "Saudi-Arabien",
  "Schweiz",
  "Senegal",
  "Serbien",
  "Seychellerne",
  "Sierra Leone",
  "Singapore",
  "Slovakiet",
  "Slovenien",
  "Somalia",
  "Spanien",
  "Sri Lanka",
  "Storbritannien",
  "Sudan",
  "Surinam",
  "Sverige",
  "Sydafrika",
  "Sydkorea",
  "Sydsudan",
  "Syrien",
  "Tadsjikistan",
  "Taiwan",
  "Tanzania",
  "Tchad",
  "Thailand",
  "Tjekkiet",
  "Togo",
  "Tonga",
  "Trinidad og Tobago",
  "Tunesien",
  "Turkmenistan",
  "Tuvalu",
  "Tyrkiet",
  "Tyskland",
  "USA",
  "Uganda",
  "Ukraine",
  "Ungarn",
  "Uruguay",
  "Usbekistan",
  "Vanuatu",
  "Vatikanstaten",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe",
  "Østrig",
  "Øvrige",
];
